<div class="cancel">
  <div class="modal-header px-0 pb-0">
    <h4 class="modal-title" id="modal-basic-title">{{localize(langSection.Term, langText.AreYouSure)}}</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissModal()"></button>
  </div>
  <div class="modal-body pb-0">
    <span>{{ localize(langSection.RequestFormPage, langText.IfYouContinue) + ', ' }} </span>
    <span>{{isNewRequest ? localize(langSection.RequestFormPage, langText.ThisRequestWillNotBeCreated) :
      localize(langSection.RequestFormPage, langText.YourEditsWillNotBeSaved)}}.</span>
  </div>
  <div class="modal-footer justify-content-center">
    <button type="button" class="btn btn-green" (click)="goBack()">{{localize(langSection.Term, langText.Yes)}}</button>
    <button type="button" class="btn btn-white" (click)="dismissModal()">{{localize(langSection.Term,
      langText.No)}}</button>
  </div>
</div>